import { render, staticRenderFns } from "./TechService.vue?vue&type=template&id=50f16c1a"
import script from "./TechService.vue?vue&type=script&lang=js"
export * from "./TechService.vue?vue&type=script&lang=js"
import style0 from "./TechService.vue?vue&type=style&index=0&id=50f16c1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports